import React from 'react';
import * as Styled from './styled';

export const BackgroundFixed: React.FC<{
  scrolledValue: number;
  isSmallProfile: boolean;
}> = ({ scrolledValue, isSmallProfile }) => (
  <Styled.BackgroundFixed
    data-testid="background-fixed-wrapper"
    scrolledValue={scrolledValue}
    isSmallProfile={isSmallProfile}
  >
    <div data-testid="background-fixed" />
  </Styled.BackgroundFixed>
);
